

<div class="mgb10">
    <label>Fecha de pago</label>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <input matInput [matDatepicker]="picker" [(ngModel)]="data.fechaPago" class="fw">
    <mat-datepicker #picker></mat-datepicker>
</div>

<div class="mgb10">
    <label>Via de pago</label>
    <select [(ngModel)]="data.viaPago" [ngModelOptions]="{standalone: true}" class="fw">
        <option [ngValue]="'Paypal'">Paypal</option>
        <option [ngValue]="'Transferencia Nacional MEX'">Transferencia Nacional MEX</option>
        <option [ngValue]="'Transferencia Nacional USA'">Transferencia Nacional USA</option>
        <option [ngValue]="'Transferencia internacional USA'">Transferencia Internacional MEX</option>
        <option [ngValue]="'Transferencia internacional MEX'">Transferencia Internacional USA</option>
    </select>

</div>

<div class="mgb10">
    <button (click)="confirmarRegistroPago()" class="darkButton fw">Registrar pago</button>
</div>